import React, { FC } from 'react';

import { shouldDisplayEyewearWarning } from 'common/models/Category';
import { Product } from 'models/product';
import { useAppContext } from 'store/appContext';

import { BubbleDisplayer } from './BubbleDisplayer';
import { WarningRow, WarningRowItem } from './EyewearWarning.css';

export const EyewearWarning: FC<{ product: Product }> = ({ product: { category } }) => {
  const { countryCode } = useAppContext();
  if (!shouldDisplayEyewearWarning(category.id, countryCode)) {
    return null;
  }

  return (
    <WarningRow data-cy="eyewear-warning-row">
      <WarningRowItem data-cy="text">WARNING: California Proposition 65</WarningRowItem>
      <WarningRowItem>
        <BubbleDisplayer />
      </WarningRowItem>
    </WarningRow>
  );
};
